import { useDispatch, useSelector } from 'react-redux';
import { StripInteractions } from '../../plot/components/StripInteractions';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import { setRulerTimestamp } from '../thunks/set-ruler-timestamp.thunk';
import { startRuler } from '../thunks/start-ruler.thunk';
import { PropsWithChildren } from 'react';

export const RulerContainer: React.FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();
  const isRulerActive = useSelector(
    isToolActiveSelector(Tool.ruler, Tool.rulerAnchored),
  );
  const isRulerAnchored = useSelector(isToolActiveSelector(Tool.rulerAnchored));

  const handler = (eventType: keyof WindowEventMap, timestamp: number) => {
    switch (eventType) {
      case 'mousemove':
        dispatch(setRulerTimestamp(timestamp));
        break;

      case 'mousedown':
        dispatch(startRuler(timestamp));
        break;
    }
  };

  if (!isRulerActive) {
    return <></>;
  }

  return (
    <StripInteractions eventHandler={handler} disabled={isRulerAnchored}>
      {children}
    </StripInteractions>
  );
};
